<template>
    <rkm-area title="Autorização">
        <Form
            :additionals="additionals"
            :form="form"
            :model="model"
        />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    props: {
        additionals: { type: Object, required: true },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    }
}
</script>